import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { alpha } from '@mui/material/styles';
import React, { useState } from "react";

interface DropdownMenuProps {
  label: string;
  items: string[];
  selectedItem: string;
  onSelect: (item: string) => void;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ label, items, selectedItem, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (item: string) => {
    onSelect(item);
    handleMenuClose();
  };

  return (
    <Box display="flex" alignItems="center">
        <Typography variant="body2" mr={1}>
            {label}
        </Typography>
        <Box
            display="flex"
            alignItems="center"
            sx={{
                cursor: 'pointer',
                px: 1,
                py: 0.5
            }}
            onClick={handleMenuOpen}
        >
            <Typography variant="h6" flex={1}>
                {selectedItem}
            </Typography>
            <ArrowDropDownIcon fontSize="small" />
        </Box>
        <Menu 
            anchorEl={anchorEl} 
            open={Boolean(anchorEl)} 
            onClose={handleMenuClose}
            sx={{
            '& .MuiMenuItem-root.Mui-selected': {
                backgroundColor: (theme) => 
                alpha(theme.palette.primary.main, 0.15), // 选中背景色
                '&:hover': {
                backgroundColor: (theme) => 
                    alpha(theme.palette.primary.main, 0.2), // 悬停时背景色
                }
            }
            }}>
            {items.map((item) => (
            <MenuItem key={item} selected={item === selectedItem} onClick={() => handleSelect(item)} 
                sx={{
                color: (theme) => 
                    item === selectedItem ? theme.palette.primary.main : 'inherit'
                }}>
                {item}
            </MenuItem>
            ))}
        </Menu>
    </Box>
  );
};

export default DropdownMenu;